import React from 'react';

import { FilterTypes } from '@candu-ai/analytics/search';
import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';
import { CollapsableTable } from '@candu-ai/analytics/ui';
import { ACTION_COLUMN } from 'canoe/components/Table/types';
import { getLocalisedNumber } from 'commons/utils';
import { TableLink } from 'dashboard/components/TableLinks';
import TimeAgo from 'dashboard/components/TimeAgo';
import { userAnalyticsPath } from 'dashboard/pages/Analytics/constants';

import { TableFilterActions } from './TableFilterActions';

interface Props {
  queryParams: QueryParamUrlObject;
}

const columns = [
  {
    key: 'userId',
    title: 'User Id',
    isSortable: true,
    colSpan: 2,
    render: (name: string, record: any) => {
      return <TableLink text={name} link={`${userAnalyticsPath(record.userId)}`} />;
    },
  },
  {
    key: 'userEmail',
    title: 'Email',
    render: (name: string, record: any) => {
      return <TableLink text={name} link={`${userAnalyticsPath(record.userId)}`} />;
    },
    colSpan: 2,
  },
  {
    key: 'views',
    title: 'Views',
    render: (value: number) => getLocalisedNumber(value, 'en-US'),
  },
  {
    key: 'lastSeen',
    render: (text: string, record: any) =>
      record.lastSeen ? <TimeAgo date={record.lastSeen as string | number} /> : 'never',

    title: 'Last View',
    isSortable: true,
  },
  {
    key: ACTION_COLUMN,
    title: 'actions',
    render: (text: string, record: any) => {
      if (record.userEmail) {
        return <TableFilterActions filterType={FilterTypes.UserEmail} value={record.userEmail} />;
      }

      return <TableFilterActions filterType={FilterTypes.UserId} value={record.userId} />;
    },
  },
];

export const ViewsByUserTable = ({ queryParams }: Props) => (
  <CollapsableTable
    queryId={QueryId.ViewsByUserTable}
    label="Views by User"
    queryParams={queryParams}
    columns={columns}
  />
);
